import classNames from 'classnames';
import { toast, ToastOptions } from 'react-toastify';
import styled from 'styled-components';
import { Warning } from 'components/Icons/Warning';

const WarningToast = styled.div`
  display: flex;
  line-height: 16px;
  flex-direction: column;
  svg {
    margin-right: 8px;
    flex-shrink: 0;
  }

  span {
    word-break: break-word;
  }

  .Toastify__toast--error {
    border-left-color: #f99100 !important;
  }
`;

const WarningTitle = styled.div`
  display: flex;
  color: #f99100;
  font-weight: 600;
  align-items: center;
  margin-bottom: 10px;
  svg {
    margin-right: 8px;
    flex-shrink: 0;
  }
`;

export const showWarning = (message: string, options: ToastOptions = {}) => {
  if (options.autoClose === false) {
    options.className = classNames(options.className || '', 'toast-with-close');
  }

  return toast.error(
    <WarningToast>
      <WarningTitle>
        <Warning size={16} fill='#f99100' /> WARNING
      </WarningTitle>
      {message}
    </WarningToast>,
    { ...options, style: { borderLeftColor: '#f99100' } }
  );
};
